import { render, staticRenderFns } from "./SimpleDate.vue?vue&type=template&id=012fda1f&scoped=true&"
import script from "./SimpleDate.vue?vue&type=script&lang=js&"
export * from "./SimpleDate.vue?vue&type=script&lang=js&"
import style0 from "./SimpleDate.vue?vue&type=style&index=0&id=012fda1f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012fda1f",
  null
  
)

export default component.exports